import React from 'react';

import './Tag.css';

// Base semantic variants
export type TagSemanticVariant = 'default' | 'info' | 'success' | 'warning' | 'error';

// Status-specific variants (map to semantic colors)
export type TagStatusVariant =
  | 'active'
  | 'paid'
  | 'completed'
  | 'pending'
  | 'in-progress'
  | 'open'
  | 'cancelled'
  | 'expired'
  | 'draft'
  | 'quoted'
  | 'neutral';

export type TagVariant = TagSemanticVariant | TagStatusVariant;

export type TagSize = 'sm' | 'md';

export interface TagProps {
  /** Visual variant */
  variant?: TagVariant;
  /** Size of the tag */
  size?: TagSize;
  /** Show a dot indicator before the text */
  showDot?: boolean;
  /** Tag content */
  children: React.ReactNode;
  /** Aria label for accessibility */
  ariaLabel?: string;
  /** Additional CSS class */
  className?: string;
}

export const Tag = React.memo(function Tag({
  variant = 'default',
  size = 'md',
  showDot = false,
  children,
  ariaLabel,
  className = '',
}: TagProps) {
  return (
    <span
      className={`tag ${className}`.trim()}
      data-variant={variant}
      data-size={size}
      aria-label={ariaLabel}
    >
      {showDot && <span className="tag__dot" />}
      {children}
    </span>
  );
});
